import { Route, Routes } from 'react-router-dom';
import Index from '../pages/Index';
import ErrorPage from '../pages/ErrorPage';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import FormPage from '../pages/FormPage';
import Payment from '../pages/Payment';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { BlogPage } from '../pages/BlogPage';
import { PostPage } from '../pages/PostPage';

const PublicRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/index" element={<Index />} />
        <Route path='/formularios/:formId' element={<FormPage />} />
        <Route path="/pagamento/:paymentId" element={<Payment />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:postId" element={<PostPage />} />

        <Route path="/error/:code" element={<ErrorPage />} />
        {/* Rota fallback para páginas não encontradas */}
        <Route path="*" element={<ErrorPage code={404} />} />
      </Routes>
      <WhatsAppButton
        allowEsc
        allowClickAway
      />
    </>
  );
};

export default PublicRoutes;
